import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { C, Input, Label } from "../components/shared";

// ─────────────────────────────────────────────────────────────────────────────
// ADMIN SETUP:
// In Firebase Console → Authentication → Add user manually:
//   Email: admin@quotemybodywork.co.uk  (or whatever you want)
//   Password: your secure password
// Then in Firestore → users collection → create document with UID of that user:
//   { role: "admin", email: "admin@quotemybodywork.co.uk" }
// ─────────────────────────────────────────────────────────────────────────────

export default function AdminLogin({ onBack, onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const doLogin = async () => {
    if (!email || !password) { setError("Please enter email and password."); return; }
    setLoading(true); setError("");
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const profileSnap = await getDoc(doc(db, "users", cred.user.uid));
      if (!profileSnap.exists() || profileSnap.data().role !== "admin") {
        await auth.signOut();
        setError("This account does not have admin access.");
        setLoading(false); return;
      }
      onSuccess();
    } catch (e) {
      setError("Incorrect email or password.");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:"100vh", background:C.dark, display:"flex", flexDirection:"column", justifyContent:"center", padding:"24px 20px", color:C.text, fontFamily:"'DM Sans',sans-serif" }}>
      <button onClick={onBack} style={{ background:"transparent", border:"none", color:C.muted, cursor:"pointer", fontFamily:"inherit", fontSize:13, display:"flex", alignItems:"center", gap:6, padding:"0 0 24px", maxWidth:460, margin:"0 auto", width:"100%" }}>← Back</button>
      <div style={{ fontSize:20, fontWeight:900, color:"#E8341A", textAlign:"center", marginBottom:3 }}>QuoteMyBodywork</div>
      <div style={{ textAlign:"center", fontSize:13, color:C.muted, marginBottom:24 }}>Admin panel</div>
      <div style={{ background:"#181818", border:`1px solid ${C.border}`, borderRadius:20, padding:"24px 20px", maxWidth:460, margin:"0 auto", width:"100%" }}>
        <h2 style={{ fontSize:20, fontWeight:900, marginBottom:6 }}>Admin sign in</h2>
        <p style={{ fontSize:13, color:"#999", marginBottom:22 }}>Restricted access — admin only.</p>
        <div style={{ marginBottom:14 }}><Label>Email</Label><Input value={email} onChange={setEmail} placeholder="admin@quotemybodywork.co.uk" type="email" /></div>
        <div style={{ marginBottom:14 }}><Label>Password</Label><Input value={password} onChange={setPassword} placeholder="Your admin password" type="password" /></div>
        {error && <div style={{ background:"#2d1010", border:"1px solid #6b2020", borderRadius:10, padding:"11px 14px", fontSize:12, color:"#f87171", marginBottom:14 }}>{error}</div>}
        <div style={{ background:"rgba(59,130,246,0.08)", border:"1px solid rgba(59,130,246,0.2)", borderRadius:10, padding:"10px 14px", fontSize:12, color:"#7fb3f5", marginBottom:16, lineHeight:1.6 }}>
          ℹ Set up your admin account in Firebase Console → Authentication, then create your user doc in Firestore → users with role: "admin"
        </div>
        <button onClick={doLogin} disabled={loading}
          style={{ width:"100%", background: loading?"#666":"#E8341A", color:"#fff", border:"none", borderRadius:13, padding:"15px", fontSize:15, fontWeight:800, cursor: loading?"not-allowed":"pointer", fontFamily:"inherit" }}>
          {loading ? "Signing in..." : "Sign in →"}
        </button>
      </div>
    </div>
  );
}
